import React, { createContext, useContext, useMemo, useState } from 'react'
import { getPromocao } from '../api/promocao.servico'
import { isEmptyObject } from '../utils/helpers/helpers'
import { MENSAGEM_ERRO_PROMOCAO } from '../utils/validadores/constantsValidadores'

const PromocaoContext = createContext()

function PromocaoProvider( props ) {
  const [ state, setState ] = useState( {
    'codigoPromocao': '',
    'dadosPromocao': {},
    'errosPromocao': '',
    'promocaoDeletada': false
  } )

  const value = useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <PromocaoContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function usePromocao() {
  const context = useContext( PromocaoContext )
  if ( !context ) {
    throw new Error( 'usePromocao deve ser usado dentro de um PromocaoProvider' )
  }

  const { state, setState } = context

  const setCodigoPromocao = codigo => {
    setState( prevState => ( {
      ...prevState,
      'codigoPromocao': codigo
    } ) )
  }

  const setErroPromocao = erro => {
    setState( prevState => ( {
      ...prevState,
      'errosPromocao': erro
    } ) )
  }

  const setDadosPromocao = promocao => {
    setState( prevState => ( {
      ...prevState,
      'dadosPromocao': promocao
    } ) )
  }

  const deleteDadosPromocao = isPromocaoDeletada => {
    setState( prevState => ( {
      ...prevState,
      'dadosPromocao': {},
      'promocaoDeletada': isPromocaoDeletada
    } ) )
  }

  const validarCodigoPromocao = async( idAssinatura, idPlano, promocaoInputada, formaPagamento, tipoAssinatura, email ) => {
    setErroPromocao( '' )
    try {
      const response = await getPromocao( idAssinatura, idPlano, promocaoInputada, formaPagamento, tipoAssinatura, email )
      if ( !isEmptyObject( response.data ) ) {
        if ( response.data.isRecommendation ) {
          setDadosPromocao( {} )
          setErroPromocao( MENSAGEM_ERRO_PROMOCAO )
          return
        }
        setCodigoPromocao( response.data.code )
        setDadosPromocao( response.data )
        setErroPromocao( '' )
      }
    } catch ( erro ) {
      setDadosPromocao( {} )
      setErroPromocao( MENSAGEM_ERRO_PROMOCAO )
    }
  }

  return {
    'codigoPromocao': state.codigoPromocao,
    'dadosPromocao': state.dadosPromocao,
    deleteDadosPromocao,
    'errosPromocao': state.errosPromocao,
    'promocaoDeletada': state.promocaoDeletada,
    setCodigoPromocao,
    validarCodigoPromocao,
  }
}

export { PromocaoProvider, usePromocao }
